import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { deleteGatewayConversionSettings } from 'config/requests/orderConversion';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify } from 'react-admin';

export function useDeleteGatewayConversionSettings() {
  const translate = useTypedTranslate();
  const notify = useNotify();

  const mutation = useMutation({
    mutationFn: ({ id }: { id: number }) => deleteGatewayConversionSettings(id),
    onError: (e) => {
      const error = e as AxiosError;
      notify(`${translate('app.notification.error')}: ${error.message}`, { type: 'error' });
    },
  });

  return { deleteGatewayConversionSettings: mutation };
}
